
<template>
    <div class="main_unit">
        <div class="prev_box">
            <router-link v-if="pageNo > 0" :to="{ name: 'dailyCheckMenuInput',
                        params:{ menuId: menuId, subMenuId: subMenuId, page: pageNo }}">
                <i class="fas fa-chevron-left prev_next_icn"></i><br>前</router-link>
        </div>
        <div class="top_unit">
            <div class="top_name_box">{{getStaffName}}</div>
        </div>
        <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
        <div v-show="!isInitLoading">
            <div class="w840_unit" >
                <div class="wd840 mgt_20">
                    <div class="error_text" v-if="validationMessage">
                        <Message :validationMessage="alertMessage" /><br>
                        <Message :validationMessage="validationMessage" />
                    </div>

                    <textarea class="texbox_h475" placeholder="コメントを入力" v-model="freeComment" maxlength="400"></textarea>
                  <div class="last_update" style="position: relative;">
                    <div class="right_icn">
                      <router-link v-if="freeCommentPage.commentHistoryFlg" :to="{ name: 'dailyCheckCommentHistoryIndex',
                              params:{ pageId: freeCommentPage.dailyCheckPageId, menuId:menuId , subMenuId:subMenuId }}" target='_blank' rel="noopener noreferrer" style="text-decoration: none">
                        <p class="comment_history_btn">コメントあり</p></router-link>
                    </div>
                  </div>
                </div>
                <div class="btn_submit letter_spa">
                    <a href="#" role="button" @click.prevent.stop="sendComent">登録</a>
                </div>
            </div>
        </div>

        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit_s">{{menuNameUpper}}</p>
                            <p class="modal_header_tit">{{menuNameLower}}</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>{{title}}<br>
                            の更新が完了しました。</p>
                        ※5秒後に自動でTOPに戻ります。<br>
                        ※未入力がある場合は、再度入力してください。
                    </div>

                    <div class="btn_submit_box">
                        <div class="btn_submit">
                            <a href="#" role="button" @click.prevent.stop="closeModel">続けて入力</a>
                        </div>
                        <div class="btn_submit2">
                            <a role="button" @click.prevent.stop="closeModalTop">TOPに戻る</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
    </div>

</template>

<script>

    //TODO:履歴遷移時のタイトル等の引数
    import PulseLoader from '@/app/components/PulseLoader.vue'
    import Message from '@/app/components/Message.vue'
    export default {
        name: 'DailyCheckFreeComment',
        components: {
            PulseLoader,
            Message
        },
        computed:{
            brandPath: function () {
                return this.$store.getters['brand/path']
            },
            getStaffName:function () {
                return  this.$store.getters['staff/data'].staffName;
            }
        },
        props:{
            title: String,
            menuId: Number,
            subMenuId: Number,
            menuNameUpper: String,
            menuNameLower: String,
        },
        data() {
            return {
                isLoading: false,
                isInitLoading:true,
                delpayPath: { name: 'dailyCheckCommentHistoryIndex' },
                freeComment:'',
                dailyCheckComments:null,
                showContent:false,
                validationMessage:'',
                pageNo: 0,
                freeCommentPage:
                    {
                        dailyCheckPageId: null,
                        dailyCheckPageNo: null,
                        dailyCheckPageName: "",
                        manualFilePath: "",
                        informationFilePath: "",
                        staffId: null,
                        staffName: "",
                        createdTime: "",
                        dailyCheckItemList: [
                            {
                                dailyCheckItemId: null,
                                dailyCheckItemNo: null,
                                dailyCheckItemName: "",
                                resultValue: null
                            }
                        ],
                        arrangementRuleList: [
                            {arrangementRuleId: null, arrangementRuleNo: null, arrangementRuleFilePath: ""}
                        ],
                        commentHistoryFlg:false,
                    },
                alertMessage:'入力エラーがあります。'
            }
        },
        created: function(){
            this.calc();
        },
        methods: {
            async calc() {
                this.isInitLoading = true

                var brandId = this.$store.getters['brand/id'];
                var topButtonId = this.subMenuId;
                var storeId = this.$store.getters['store/data'].store_id;
                var datetime = this.dateFormat();
                var url = this.$apiEndpoint + 'user/brand/' + brandId + '/daily_menu/' + topButtonId + '/store/' + storeId + '?datetime=' + datetime;

                await this.$axios
                    .get(url)
                    .then(response => (this.freeCommentPage = response.data.dailyCheckContentsList.dailyCheckPageList.filter(x => x.dailyCheckPageNo == 21)[0] ,
                        this.pageNo = response.data.dailyCheckContentsList.totalPage-1,
                        this.$store.dispatch('dailyCheckPage/set', response.data.dailyCheckContentsList.dailyCheckPageList))
                    )
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params: {brandPath: this.$route.params.brandPath}}
                            }
                        }
                        if (err.customError) {
                            error = Object.assign(error, err.customError)
                        }
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }).finally(() => this.isInitLoading = false);

                // エラーメッセージ及びコメント入力内容を初期化
                this.validationMessage = '';
                this.freeComment ='';

            },
            async sendComent(){

                this.isLoading = true;

                //バリデーションフラグ
                var validationFlg = true;
                //バリデーションチェック(桁数)
                this.validationMessage = '';

                var apiResponseFlg = true;

                if(String(this.freeComment).length > 400){
                    this.validationMessage="コメントは400文字以下で入力してください。";
                    validationFlg = false;
                    this.scrollTop();
                }

                if(!validationFlg){
                    this.isLoading = false;
                    //処理終了
                    return null;
                }

                //URL生成
                var brandId = this.$store.getters['brand/id'];
                var storeId = this.$store.getters['store/data'].store_id;
                var url = this.$apiEndpoint + 'user/brand/' + brandId + '/store/' + storeId + '/daily_check_page'

                //リクエストデータ生成
                var dailyObj = new Object();
                var staff_id = this.$store.getters['staff/data'].staffId;
                var staff_name = this.$store.getters['staff/data'].staffName;
                var authority_kbn = this.$store.getters['staff/authorityKbn'];
                dailyObj['daily_check_page_id'] = this.freeCommentPage.dailyCheckPageId;
                dailyObj['daily_check_item_list'] = [];
                var comment = new Object();
                comment['commentText'] = this.freeComment;
                dailyObj['comments'] = [comment];
                var daily_check_page_list = new Object();
                daily_check_page_list = [
                    dailyObj
                ];

                //更新API呼び出し
                await this.$axios
                    .post(url, {staff_id:staff_id,staff_name:staff_name,authority_kbn:authority_kbn,daily_check_page_list:daily_check_page_list})
                    .then()
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        apiResponseFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError);

                            if(error.code == 400){
                                this.validationMessage =  error.message;
                                this.scrollTop();
                            }
                        }
                        if(error.code !== 400){
                            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                        }
                    }).finally(() => this.isLoading = false);

                // 処理エラーがない場合
                if(apiResponseFlg){
                    this.showContent = true;
                    //５秒後にTOPへ遷移する
                    this.startTimer();
                    this.calc();
                }
            },
            dateFormat(){
                let nowDate = new Date();
                let year = nowDate.getFullYear();
                let month = ("0" + (nowDate.getMonth()+1)).slice(-2);
                let day = ("0" + nowDate.getDate()).slice(-2);
                let hours = ("0" + nowDate.getHours()).slice(-2);
                let minutes = ("0" + nowDate.getMinutes()).slice(-2);
                let seconds = ("0" + nowDate.getSeconds()).slice(-2);

                let format_str = 'YYYYMMDDhhmmss'
                format_str = format_str.replace(/YYYY/g,year);
                format_str = format_str.replace(/MM/g,month);
                format_str = format_str.replace(/DD/g,day);
                format_str = format_str.replace(/hh/g,hours);
                format_str = format_str.replace(/mm/g,minutes);
                format_str = format_str.replace(/ss/g,seconds);
                return format_str;
            },
            closeModel() {
                this.showContent = false;
                clearInterval(this.timer);
                this.timer = 0;
            },
            startTimer:function(){
                this.time = 5;
                this.stopTImer();
                this.timer = setInterval(() => this.countdown(),1000);
            },
            //タイマー設定
            stopTImer:function(){
                if(this.timer){
                    clearInterval(this.timer);
                    this.timer = 0;
                }
            },
            countdown:function () {
                if(this.time > 0){
                    this.time--;
                }
                else{
                    clearInterval(this.timer);
                    this.timer = 0;
                    this.closeModalTop();
                }
            },
            destoryed(){
                this.stopTImer();
            },
            closeModalTop(){
                clearInterval(this.timer);
                this.timer = 0;
                this.$router.push({name: 'top', params: { brandPath: this.$route.params.brandPath}});
            },
            scrollTop() {
                window.scrollTo(0,0);
            }
        }
    }
</script>
